document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tab').forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelector(tab.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
  });